import { render, staticRenderFns } from "./agencyDetail.vue?vue&type=template&id=8b1b9516&scoped=true&"
import script from "./agencyDetail.vue?vue&type=script&lang=js&"
export * from "./agencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./agencyDetail.vue?vue&type=style&index=0&id=8b1b9516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b9516",
  null
  
)

export default component.exports